



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import validate from "@/directives/validateDirect";
import { ValidationModel } from "@/services/validation/types";

@Component({
    directives: {
        validate
    }
})
export default class vscNameInput extends Vue {
    @Prop() private value!: string;
    @Prop() placeholder!: string;
    @Prop() validator!: ValidationModel;

    nameEditMode = false;

    get inputValue() {
        return this.value;
    }

    set inputValue(input) {
        this.$emit("input", input);
    }

    toggleEditMode(value: boolean) {
        if (value) {
            this.nameEditMode = true;
            this.autoScale();
            // @ts-ignore
            this.$nextTick(() => this.$refs.nameInput.focus());
        } else {
            // if input is invalid do nothing, stay in edit mode
            if (typeof this.validator.state !== "undefined" &&
                this.validator.state === false) {
                return;
            }
            this.nameEditMode = false;
        }
        this.$emit("nameEditMode", this.nameEditMode);
    }

    @Watch("value", { deep: true }) routeChanged() {
        this.autoScale();
    }

    autoScale() {
        this.$nextTick(() => {
            // @ts-ignore
            this.$refs.nameInput.$el.style.height = 0;
            // @ts-ignore
            this.$refs.nameInput.$el.style.height = (this.$refs.nameInput.$el.scrollHeight) + "px";
        });
    }

    preventNewLine() {
        this.value.replace(/(\r\n|\n|\r)/gm, "");
    }
}
